import api from '@/api'
import { service } from '@/utils/request'
import { setToken, setStorage, removeToken, removeStorage } from '@/utils/auth'
// import mock from '@/mock'

const user = {
  state: {
    token: '',
    userToken: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: '',
    routes: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_TOKEN: (state, token) => {
      state.userToken = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_ROUTES: (state, routes) => {
      state.routes = routes
    }
  },

  actions: {
    // Login ({ commit }, userInfo) {
    //   return api.user.Login(userInfo)
    //     .then(res => {
    //       if (res.status === 'ok') {
    //         const result = res.data
    //         setToken(result.token)
    //         commit('SET_TOKEN', result.token)

    //         setStorage('USER_TOKEN', result.user_token) // 个性化推送管理v494
    //         commit('SET_USER_TOKEN', result.user_token)
    //       }
    //       return res
    //     })
    //     .catch(() => {})
    // },
    GetInfo ({ commit }) {
      return new Promise(async (resolve, reject) => {
        const { data: info } = await api.user.getUserInfo()
        // const { data: routes } = await api.auth.getRoutes()
        // const { data: info } = mock.info
        // const { data: routes } = mock.routes
        // const { data: info } = await vm.$http('https://easy-mock.com/mock/5a6e8b09376cc81223703f1c/admin/index/profile')
        // const { data: routes } = await vm.$http('https://easy-mock.com/mock/5a6e8b09376cc81223703f1c/admin/auth_rule/getRuleList')
        const result = {
          ...info
        }
        setStorage('USER_INFO', JSON.stringify(result))
        setStorage('AGREE_SERVICE_CHANGE', parseInt(result.notice_tag))
        commit('SET_NAME', result.nickname)
        commit('SET_INFO', result)
        resolve(result)
      })
    },
    Logout ({ commit, state }) {
      return new Promise((resolve, reject) => {
        removeToken()
        removeStorage('USER_INFO')
        resolve()
      })
    },
    async handleLogin ({ commit, state }, data) {
      const res = await api.user.login(data)
      if (res.status === 'ok') {
        // const user = {
        //   phone: res.data.phone,
        //   nickname: res.data.nickname,
        //   authentication_status: res.data.authentication_status,
        //   authentication_status_desc: res.data.authentication_status_desc
        // }
        // commit('SET_INFO', user)
        const token = res.data.user_token
        service.defaults.headers.MAuthorization = 'b2ce5f4a52637000ad461899e5ea4a24:' + token
        commit('SET_TOKEN', token)
        setToken(token)
      }
      return res
    },
    AddAssets ({ commit, state }, data) {
      const userInfo = Object.assign(state.info, data)
      console.log(state, userInfo)
      commit('SET_INFO', userInfo)
    }

  }
}

export default user
